(function() {
  $(document).ready(function() {
    var topHeight = $('#top').outerHeight();
    var targetHeight = window.innerHeight * 0.4;
    var theKit = $('.hero--thekit');
    var howTo = $('.hero--howto');
    var newsReviews = $('.hero--newsreviews');
    addScrollListener();
    if ($('#top').offset().top - $(window).scrollTop() < -Math.abs(topHeight)) {
      toggleHeader();
    }
    $('.hero--site-header--link > a').click(function() {
      removeScrollListener();
      if ($(this).text() == 'The Kit') {
        updateHighlight(theKit);
      } else if ($(this).text() == 'How To') {
        updateHighlight(howTo);
      } else if ($(this).text() == 'Reviews') {
        updateHighlight(newsReviews);
      }
      setTimeout(function() {
        addScrollListener();
      }, 1200);
    });
    function toggleHeader() {
      var heroHeader = $('#hero--site-header');
      var siteHeader = $('#shopify-section-static-header');
      var megaMenu = $('#shopify-section-NB-megamenu-container');
      if (heroHeader.hasClass('active')) {
        heroHeader.removeClass('active');
        siteHeader.show();
        megaMenu.show();
        updateHighlight(theKit);
      } else {
        heroHeader.addClass('active');
        siteHeader.hide();
        megaMenu.hide();
      }
    }
    function updateHighlight(target) {
      clearHighlights = function() {
        $('.highlighted').each(function() {
          $(this).removeClass('highlighted');
        });
      };
      if (target.hasClass('hero--thekit')) {
        clearHighlights();
        $('.hero--site-header--nav-actions > .hero--site-header--link:nth-child(1)').addClass('highlighted');
      } else if (target.hasClass('hero--howto')) {
        clearHighlights();
        $('.hero--site-header--nav-actions > .hero--site-header--link:nth-child(2)').addClass('highlighted');
      } else if (target.hasClass('hero--newsreviews')) {
        clearHighlights();
        $('.hero--site-header--nav-actions > .hero--site-header--link:nth-child(3)').addClass('highlighted');
      }
    }
    function addScrollListener() {
      $(document).on('scroll', scrollListen);
    }
    function removeScrollListener() {
      $(document).off('scroll', scrollListen);
    }
    function scrollListen() {
      var windowTop = $(window).scrollTop();
      if (
        $('#top').offset().top - windowTop < -Math.abs(topHeight - 200) &&
        !$('#hero--site-header').hasClass('active')
      ) {
        toggleHeader();
      } else if ($('#top').offset().top - windowTop > -300 && $('#hero--site-header').hasClass('active')) {
        toggleHeader();
      } else if (
        theKit.offset().top - windowTop > targetHeight - 50 &&
        theKit.offset().top - windowTop < targetHeight + 50
      ) {
        updateHighlight(theKit);
      } else if (
        howTo.offset().top - windowTop > targetHeight - 50 &&
        howTo.offset().top - windowTop < targetHeight + 50
      ) {
        updateHighlight(howTo);
      } else if (
        newsReviews.offset().top - windowTop > targetHeight - 50 &&
        newsReviews.offset().top - windowTop < targetHeight + 50
      ) {
        updateHighlight(newsReviews);
      }
    }
  });
})();
